import type { RejectReturnRequestLineItemsBodyDto } from "../generated/schema";
import { useApiMutation } from "./use-api-mutation";
import useInvalidateShop from "./use-invalidate-shop";

interface UseRejectReturnRequestParams {
  onSuccess: () => void;
  onMutate: () => void;
  onError?: () => void;
  shopId: string;
}

export default function useRejectReturnRequest(
  params: UseRejectReturnRequestParams,
) {
  const invalidateShop = useInvalidateShop(params.shopId);

  return useApiMutation(
    "post",
    "/shops/{shopId}/return-requests/{returnRequestId}/line-items/reject",
    {
      invalidate: invalidateShop,
      onMutate: () => params.onMutate(),
      onSuccess: () => {
        params.onSuccess();
      },
      onError: () => {
        params.onError?.();
      },
      mapVariables: ({
        variables,
        returnRequestId,
      }: {
        variables: RejectReturnRequestLineItemsBodyDto;
        returnRequestId: string;
      }) => ({
        params: { path: { shopId: params.shopId, returnRequestId } },
        body: variables,
      }),
    },
  );
}
